export const filterSelectableSuggestions = (
    incomingSuggestedAttributes,
    categoryAttributes
) => {
    const selectableSuggestions = [];
    incomingSuggestedAttributes.forEach((sa) => {
        const categoryAttribute = categoryAttributes.find(
            (a) => a.id === sa.id
        );
        if (categoryAttribute) {
            const suggestedAttribute = { id: sa.id, values: [] };
            sa.values.forEach((v) => {
                const isSelectableSuggestion = categoryAttribute.options.some(
                    (o) => o.value === v
                );
                const isMaxReached =
                    suggestedAttribute.values.length >=
                    categoryAttribute.maxNumberOfValues;
                if (isSelectableSuggestion && !isMaxReached) {
                    suggestedAttribute.values.push(v);
                }
            });
            selectableSuggestions.push(suggestedAttribute);
        }
    });
    return selectableSuggestions;
};

export const filterCombinedSelectableSuggestions = (
    primarySuggestedAttributes,
    secondarySuggestedAttributes,
    categoryAttributes
) => {
    const selectableSuggestions = [];
    categoryAttributes.forEach((categoryAttribute) => {
        const primarySuggestedAttribute = primarySuggestedAttributes.find(
            (psa) => psa.id == categoryAttribute.id
        );
        const secondarySuggestedAttribute = secondarySuggestedAttributes.find(
            (ssa) => ssa.id == categoryAttribute.id
        );
        const suggestedAttributeValues = [];
        if (primarySuggestedAttribute) {
            primarySuggestedAttribute.values.forEach((v) => {
                const isSelectableSuggestion = categoryAttribute.options.some(
                    (o) => o.value === v
                );
                const isMaxReached =
                    suggestedAttributeValues.length >=
                    categoryAttribute.maxNumberOfValues;
                if (isSelectableSuggestion && !isMaxReached) {
                    suggestedAttributeValues.push(v);
                }
            });
        }
        if (secondarySuggestedAttribute) {
            secondarySuggestedAttribute.values.forEach((v) => {
                const isSelectableSuggestion = categoryAttribute.options.some(
                    (o) => o.value === v
                );
                const isAlreadySuggested = suggestedAttributeValues.some(
                    (o) => o === v
                );
                const isMaxReached =
                    suggestedAttributeValues.length >=
                    categoryAttribute.maxNumberOfValues;
                if (
                    isSelectableSuggestion &&
                    !isMaxReached &&
                    !isAlreadySuggested
                ) {
                    suggestedAttributeValues.push(v);
                }
            });
        }
        if (suggestedAttributeValues.length > 0) {
            selectableSuggestions.push({
                id: categoryAttribute.id,
                values: suggestedAttributeValues
            });
        }
    });
    return selectableSuggestions;
};
